// Xbox Achievement Component
const achievementSound = new Audio('/audio/XboxAchievement.mp3');

export function showAchievement(title, score = 100) {
    // Create achievement container if it doesn't exist
    let achievementContainer = document.getElementById('xbox-achievement-container');
    if (!achievementContainer) {
        achievementContainer = createAchievementContainer();
        document.body.appendChild(achievementContainer);
    }

    // Set achievement details
    const achievementNameEl = achievementContainer.querySelector('.achiev_name');
    const achievementScoreEl = achievementContainer.querySelector('.acheive_score');
    const unlockedTextEl = achievementContainer.querySelector('.unlocked');

    achievementNameEl.innerText = title;
    achievementScoreEl.innerText = score;
    unlockedTextEl.innerText = 'Achievement unlocked';

    // Play sound
    achievementSound.play().catch(err => {
        console.log('Could not play achievement sound:', err);
    });

    // Add animation classes
    const circle = achievementContainer.querySelector('.circle');
    const banner = achievementContainer.querySelector('.banner');
    const achieveDisp = achievementContainer.querySelector('.achieve_disp');

    circle.classList.add('circle_animate');
    banner.classList.add('banner-animate');
    achieveDisp.classList.add('achieve_disp_animate');

    // Remove animation classes after completion
    setTimeout(() => {
        circle.classList.remove('circle_animate');
        banner.classList.remove('banner-animate');
        achieveDisp.classList.remove('achieve_disp_animate');
    }, 10500);
}

function createAchievementContainer() {
    const container = document.createElement('div');
    container.id = 'xbox-achievement-container';
    container.className = 'achievement';
    container.setAttribute('aria-live', 'polite');

    container.innerHTML = `
        <div class="animation">
            <div class="circle">
                <div class="img trophy_animate trophy_img">
                    <img class="trophy_1" src="https://dl.dropboxusercontent.com/s/k0n14tzcl4q61le/trophy_full.svg"/>
                    <img class="trophy_2" src="https://dl.dropboxusercontent.com/s/cd4k1h6w1c8an9j/trophy_no_handles.svg"/>
                </div>
                <div class="img xbox_img">
                    <img src="https://dl.dropboxusercontent.com/s/uopiulb5yeo1twm/xbox.svg?dl=0"/>
                </div>
            </div>
            <div class="banner-outer">
                <div class="banner">
                    <div class="achieve_disp">
                        <span class="unlocked"></span>
                        <div class="score_disp">
                            <div class="gamerscore">
                                <img width="20px" src="https://dl.dropboxusercontent.com/s/gdqf5amvjkx9rfb/G.svg?dl=0"/>
                                <span class="acheive_score"></span>
                            </div>
                            <span class="hyphen_sep">-</span>
                            <span class="achiev_name"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;

    return container;
}
